<template>
  <div class="sidenav">
    <div class="sidenav__backdrop" @click="$emit('close')"></div>
    <transition name="slide-side">
      <nav v-show="slideInMenu" class="sidenav__menu" aria-label="go home">
        <div class="spacing__mb_4 close" @click="$emit('close')">
          <i class="icon x24 icon_24_close"></i>
        </div>
        <a class="text__content text__link spacing__mb_3" @click="onItemClick('features')">
          {{ $t('navbar.features') }}
        </a>
        <a class="text__content text__link spacing__mb_3" @click="onItemClick('contact')">
          {{ $t('navbar.contact') }}
        </a>
        <router-link to="/access" @click="$emit('close')">
          <button class="button_secondary access" @click="$emit('close')">
            {{ $t('navbar.request_access') }}
          </button>
        </router-link>
      </nav>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'TheSidebarNav',
  props: {
    slideInMenu: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    scrollTo(ref) {
      document.querySelector(`#${ref}`).scrollIntoView({
        behavior: 'smooth',
      })
    },
    onItemClick(ref) {
      this.$emit('close')
      this.scrollTo(ref)
    },
  },
}
</script>

<style lang="scss" scoped>
.sidenav {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  &__backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
  }

  &__menu {
    height: 100%;
    width: 60%;
    background-color: white;
    position: fixed;
    top: 0;
    right: 0;
    box-sizing: border-box;
    padding: 32px 19px;
    text-align: right;
    border-radius: 5px;
    display: flex;
    flex-flow: column;

    & .close {
      cursor: pointer;
    }

    & button {
      width: 153px;
      height: 48px;
    }
  }
}
</style>
